module.exports = __webpack_public_path__ + "img/empty.7a316964.svg";